:host {
  display: block;
}

.pills {
  line-height: 44px;
  min-height: 44px;
  display: none;
}

@media screen and (min-width: 980px) {
  .pills {
    display: block;
    margin: -6px 0 12px;
  }
}

.pills__tooltip {
  font-size: 14px;
  line-height: 1.4285714286;
  font-weight: bold;
}

:host(:not([dir="rtl"])) .pill:not(:first-child) {
  margin-left: 8px;
}

:host([dir="rtl"]) .pill:not(:first-child) {
  margin-right: 8px;
}